import React from 'react'
import BarChart from '../../components/Chart/BarChart/BarChart'
import StackBarChart from '../../components/Chart/StackBarChart/StackBarChart';
import {  useSelector } from 'react-redux';

const UnitRegionAdminReports = () => {
        const {
                directMaterial,
                personnelPayments,
                miscExpenses,
                indirectMaterial,
                ebitda,
                profitLossGraph,
                power,
                revenue,
        } = useSelector((state) => state.unitReport);

        const directMaterialData = {
                labels: directMaterial?.map((item) => item.YEAR) || [],
                datasets: [
                        {
                                label: 'Direct Material',
                                backgroundColor: '#2E90FA',
                                data: directMaterial?.map((item) => item.PERCENTAGE) || [],
                        },
                ],
        };

        const personnelPaymentsData = {
                labels: personnelPayments?.map((item) => item.YEAR) || [],
                datasets: [
                        {
                                label: 'Personnel Payment',
                                backgroundColor: '#2E90FA',
                                data:
                                        personnelPayments?.map((item) =>
                                                parseFloat(
                                                        item?.PERSONNEL_PAYMENT.replace(/,/g, ''),
                                                ),
                                        ) || [],
                        },
                ],
        };

        const indirectMaterialData = {
                labels: indirectMaterial?.map((item) => item.YEAR) || [],
                datasets: [
                        {
                                label: 'Indirect Material',
                                backgroundColor: '#2E90FA',
                                data:
                                        indirectMaterial?.map((item) =>
                                                parseFloat(
                                                        item?.INDIRECT_MATERIAL.replace(/,/g, ''),
                                                ),
                                        ) || [],
                        },
                ],
        };

        const miscExpensesData = {
                labels: miscExpenses?.map((item) => item.YEAR) || [],
                datasets: [
                        {
                                label: 'Misc. Expenses',
                                backgroundColor: '#2E90FA',
                                data:
                                        miscExpenses?.map((item) =>
                                                parseFloat(
                                                        item?.MISCELLANEOUS_EXPENSES.replace(
                                                                /,/g,
                                                                '',
                                                        ),
                                                ),
                                        ) || [],
                        },
                ],
        };

        const ebitdaData = {
                labels: ebitda?.map((item) => item.YEAR) || [],
                datasets: [
                        {
                                label: 'EBITDA',
                                backgroundColor: '#2E90FA',
                                data: ebitda?.map((item) => item?.PERCENTAGE) || [],
                        },
                ],
        };

        const powerData = {
                labels: power?.map((item) => item.YEAR) || [],
                datasets: [
                        {
                                label: 'Power & Fuel',
                                backgroundColor: '#2E90FA',
                                data:
                                        power?.map((item) =>
                                                parseFloat(item?.POWER_SUPPLIES.replace(/,/g, '')),
                                        ) || [],
                        },
                ],
        };

        const profitLossData = {
                labels: profitLossGraph?.map((item) => item.YEAR) || [],
                datasets: [
                        {
                                label: 'Margin (A-B)',
                                backgroundColor: '#FF4405',
                                data: profitLossGraph?.map((item) => item?.PERCENTAGE) || [],
                        },
                ],
        };

        const revenueData = {
                labels: revenue?.map((item) => item.YEAR) || [],
                datasets: [
                        {
                                label: 'Revenue- BHEL ',
                                backgroundColor: '#2E90FA',
                                data: revenue?.map((item) => parseFloat(item?.BHEL_REVENUE.replace(/,/g, ''))) || [],
                        },

                        {
                                label: 'Revenue- Non BHEL ',
                                backgroundColor: '#47CD89',
                                data: revenue?.map((item) => parseFloat(item?.NON_BHEL_REVENUE.replace(/,/g, ''))) || [],
                        },
                        // {
                        //         type: 'line',
                        //         label: 'Average',
                        //         data:
                        //                 revenue?.map((item) =>
                        //                         parseFloat(item?.TOTAL_REVENUE.replace(/,/g, '')),
                        //                 ) || [],
                        //         borderColor: '#F79009',
                        //         backgroundColor: '#F79009',
                        //         borderWidth: 2,
                        //         tension: 0.8,
                        //         fill: false,
                        //         pointBackgroundColor: '#fff',
                        //         pointBorderColor: '#F79009',
                        //         pointRadius: 5,
                        //         pointHoverRadius: 6,
                        //         yAxisID: 'y',
                        // },
                ],
        };

        return (
                <div className="flex flex-col gap-4">
                        Operating Ratio
                        <div className="flex gap-[24px]">
                                <div className="w-full border-[1px] border-color-[#F8F9FA] p-[20px] rounded-[8px] pb-[54px] bg-[#FFFFFF]">
                                        <div>
                                                <h1 className="text-[#475467] font-inter text-md font-semibold">Direct Material</h1>
                                                <div className="h-[374px]">
                                                        <BarChart
                                                                labels={directMaterialData.labels}
                                                                datasets={directMaterialData.datasets}
                                                                yAxisAsPercentage={true}
                                                        />
                                                </div>
                                        </div>
                                </div>
                                <div className="w-full border-[1px] border-color-[#F8F9FA] p-[20px] rounded-[8px] pb-[54px] bg-[#FFFFFF]">
                                        <div>
                                                <h1 className="text-[#475467] font-inter text-md font-semibold">Personnel Payment</h1>
                                                <div className="h-[374px]">
                                                        <BarChart
                                                                labels={personnelPaymentsData.labels}
                                                                datasets={personnelPaymentsData.datasets}
                                                                yAxisAsPercentage={false}
                                                        />
                                                </div>
                                        </div>
                                </div>
                        </div>
                        <div className="flex gap-[24px]">
                                <div className="w-full border-[1px] border-color-[#F8F9FA] p-[20px] rounded-[8px] pb-[54px] bg-[#FFFFFF]">
                                        <div>
                                                <h1 className="text-[#475467] font-inter text-md font-semibold">EBITDA</h1>
                                                <div className="h-[374px]">
                                                        <BarChart
                                                                labels={ebitdaData.labels}
                                                                datasets={ebitdaData.datasets}
                                                                yAxisAsPercentage={true}
                                                        />
                                                </div>
                                        </div>
                                </div>
                                <div className="w-full border-[1px] border-color-[#F8F9FA] p-[20px] rounded-[8px] pb-[54px] bg-[#FFFFFF]">
                                        <div>
                                                <h1 className="text-[#475467] font-inter text-md font-semibold">Margin (A-B)</h1>
                                                <div className="h-[374px]">
                                                        <BarChart
                                                                labels={profitLossData.labels}
                                                                datasets={profitLossData.datasets}
                                                                yAxisAsPercentage={true}
                                                        />
                                                </div>
                                        </div>
                                </div>
                        </div>
                        <div className="flex gap-[24px]">
                                <div className="w-full border-[1px] border-color-[#F8F9FA] p-[20px] rounded-[8px] pb-[54px] bg-[#FFFFFF]">
                                        <div>
                                                <h1 className="text-[#475467] font-inter text-md font-semibold">Indirect Material</h1>
                                                <div className="h-[374px]">
                                                        <BarChart
                                                                labels={indirectMaterialData.labels}
                                                                datasets={indirectMaterialData.datasets}
                                                                yAxisAsPercentage={false}
                                                        />
                                                </div>
                                        </div>
                                </div>
                                <div className="w-full border-[1px] border-color-[#F8F9FA] p-[20px] rounded-[8px] pb-[54px] bg-[#FFFFFF]">
                                        <div>
                                                <h1 className="text-[#475467] font-inter text-md font-semibold">Power & Fuel</h1>
                                                <div className="h-[374px]">
                                                        <BarChart
                                                                labels={powerData.labels}
                                                                datasets={powerData.datasets}
                                                                yAxisAsPercentage={false}
                                                        />
                                                </div>
                                        </div>
                                </div>
                        </div>
                        <div className="flex gap-[24px]">
                                <div className="w-full border-[1px] border-color-[#F8F9FA] p-[20px] rounded-[8px] pb-[54px] bg-[#FFFFFF]">
                                        <div>
                                                <h1 className="text-[#475467] font-inter text-md font-semibold">Revenue</h1>
                                                <div className="h-[374px]">
                                                        <BarChart
                                                                labels={revenueData?.labels}
                                                                datasets={revenueData?.datasets}
                                                                yAxisAsPercentage={false}
                                                        />
                                                </div>
                                        </div>
                                </div>
                                <div className="w-full border-[1px] border-color-[#F8F9FA] p-[20px] rounded-[8px] pb-[54px] bg-[#FFFFFF]">
                                        <div>
                                                <h1 className="text-[#475467] font-inter text-md font-semibold">Misc. Expenses</h1>
                                                <div className="h-[374px]">
                                                        <BarChart
                                                                labels={miscExpensesData.labels}
                                                                datasets={miscExpensesData.datasets}
                                                                yAxisAsPercentage={false}
                                                        />
                                                </div>
                                        </div>
                                </div>
                        </div>
                </div>
        );
};

export default UnitRegionAdminReports
